<template>
  <vs-popup class="step-template-list-popup"
            :active.sync="popupActive"
            title="Step Templates"
            fullscreen>
    <div class="step-template-list">

      <div v-if="loading" class="loading-container">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>

      <div v-else-if="templates.length === 0" class="empty-state">
        <p>No step templates found</p>
      </div>

      <div v-else class="template-grid">
        <vs-card v-for="template in templates"
                 :key="template.id"
                 class="template-card">
          <div class="template-card-content">
            <div class="template-info">
              <h4>{{ template.name }}</h4>
              <p class="template-description">{{ template.description }}</p>
            </div>
            <div class="template-actions">
              <!--<vs-button @click="editTemplate(template)"
             color="primary"
             type="border"
             size="small">
    Edit
  </vs-button>-->
              <vs-button @click="useTemplate(template)"
                         color="primary"
                         type="border"
                         size="small">
                {{$t('Use')}}
              </vs-button>
              <vs-button @click="deleteTemplate(template.id)"
                         color="danger"
                         type="border"
                         size="small">
                {{$t('Delete')}}
              </vs-button>

              <vs-button @click="viewRawHtml(template)"
                         color="dark"
                         type="border"
                         size="small">
                {{$t('Preview')}}
              </vs-button>
            </div>
          </div>
        </vs-card>
      </div>

      <!-- Raw HTML Viewer Popup -->
      <vs-popup class="raw-html-popup"
                :active.sync="showRawHtml"
                :title="$t('Preview')">
        <div class="raw-html-container">
          <div v-html="currentRawHtml"
                       readonly
                       height="400px" />
          <div class="popup-actions">
            <vs-button @click="copyToClipboard" color="primary" type="filled">
              {{$t('CopyToClipboard')}}
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </vs-popup>
</template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

  export default {
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        templates: [],
        loading: false,
        showRawHtml: false,
        currentRawHtml: '',
        popupActive: this.isActive
      };
    },
    watch: {
      isActive(val) {
        this.popupActive = val;
        if (val) {
          this.loadTemplates();
        }
      },
      popupActive(val) {
        this.$emit('update:isActive', val);
      }
    },
    mounted() {
      if (this.isActive) {
        this.loadTemplates();
      }
    },
    methods: {
      async loadTemplates() {
        const instance = this;
        instance.loading = true;

        const query = `
        query StepTemplates {
          stepTemplates {
            id
            name
            description
            rawContentHTML
          }
        }
      `;

        const req = {
          query: query
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          instance.loading = false;
          if (response && response.data) {
            instance.templates = response.data.data.stepTemplates || [];
          }
        }).catch(function (err) {
          instance.loading = false;
          console.error('Could not load step templates: ', err);
          instance.$vs.notify({
            title: 'Error',
            text: 'Failed to load step templates',
            color: 'danger'
          });
        });
      },

      async deleteTemplate(id) {
        const instance = this;

        const mutation = `
        mutation DeleteStepTemplate($id: Int!) {
          deleteStepTemplate(id: $id) {
          }
        }
      `;

        const req = {
          query: mutation,
          variables: { id } 
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data) {
            instance.$vs.notify({
              title: 'Deleted step template',
              color: 'success'
            });
            instance.loadTemplates();
          }
        }).catch(function (err) {
          console.error('Could not delete step template: ', err);
          instance.$vs.notify({
            title: 'Error',
            text: 'Failed to delete step template',
            color: 'danger'
          });
        });
      },

      editTemplate(template) {
        this.$emit('edit-template', template);
      },

      useTemplate(template) {
        this.$emit('use-template', template.rawContentHTML);
      },

      viewRawHtml(template) {
        this.currentRawHtml = template.rawContentHTML || '';
        this.showRawHtml = true;
      },

      copyToClipboard() {
        const textarea = document.createElement('textarea');
        textarea.value = this.currentRawHtml;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        this.$vs.notify({
          title: 'Copied',
          text: 'HTML copied to clipboard',
          color: 'success'
        });
      },

      formatDate(date) {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
      }
    }
  };
</script>

<style scoped>
  .step-template-list {
    padding: 20px;
  }

  .list-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
  }

  .loading-container {
    padding: 40px;
    text-align: center;
  }

  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;
  }

    .empty-state p {
      font-size: 18px;
      margin: 0;
    }

  .template-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
  }

  .template-card {
    transition: transform 0.2s, box-shadow 0.2s;
  }

    .template-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    }

  .template-card-content {
    padding: 10px;
  }

  .template-info h4 {
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .template-description {
    color: #666;
    font-size: 14px;
    margin: 0 0 15px 0;
    line-height: 1.5;
  }

  .template-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
    flex-wrap: wrap;
  }

  .raw-html-container {
    padding: 20px;
  }

  .popup-actions {
    margin-top: 20px;
    text-align: right;
  }
</style>

<style>
  .step-template-list-popup .vs-popup {
    width: 95%;
    max-width: 1400px;
  }

  .raw-html-popup .vs-popup {
    width: 90%;
    max-width: 800px;
  }
</style>
